<template>
  <div class="whole">
    <div class="breadcrumbs flex ai">
      <div @click="router.push('/mobileHome')" class="breadcrumbs-txt">主页</div>
      <img class="iconArrow" src="@/assets/iconArrow.png" alt="" />
      <div class="breadcrumbs-txt1">畅销明星 Best-Selling Star</div>
    </div>
    <div class="main-content">
      <div class="flex column" style="padding: 0 0.32rem; box-sizing: border-box">
        <img class="banner" src="@/assets/mobile/star/banner.png" alt="" />
        <div class="title">畅销明星</div>
        <div class="txt">BEST-SELLING STAR</div>
        <div class="nutrition-box">
          <img class="nutrition" src="@/assets/mobile/star/product1.png" alt="" />
          <img class="nutrition" src="@/assets/mobile/star/product2.png" alt="" />
          <img class="nutrition" src="@/assets/mobile/star/product4.jpg" alt="" />
          <img class="nutrition" src="@/assets/mobile/star/product6.jpg" alt="" />
          <img class="nutrition" src="@/assets/mobile/star/product5.jpg" alt="" />
          <img class="nutrition" src="@/assets/mobile/star/product3.png" alt="" />
        </div>
      </div>
      <MobileFooter />
    </div>
  </div>
</template>

<script setup>
import MobileFooter from "@/components/mobileFooter.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
</script>

<style src="./mobileBestSellingStar.css" scoped></style>
